
export default {
    props: {
        enabled: {
            required: false,
            default: false
        }
    }
};
